import Repository from '@/repositories/base/Repository';
import IInternalTableSaveDataArrayRequestParams from '@/repositories/parameters/IInternalTableSaveDataArrayRequestParams';
import IDisreguardTotalsByGroupRequestParams from '@/views/cashFlow/predictedFlow/interfaces/requests/IDisreguardTotalsByGroupRequestParams';
import CashFlowTablesEnum from '@/views/cashFlowGroupers/mainGrouper/enums/CashFlowTablesEnum';

export default class CashFlowActionRepository extends Repository {
  public async release(
    companyGroupId: number,
    grouperType: CashFlowTablesEnum,
    items: IInternalTableSaveDataArrayRequestParams[],
  ): Promise<void> {
    await this.datasource.patch(
      `company-groups/${companyGroupId}/cash-flow/predicted/actions/release`,
      {
        grouper_table: grouperType,
        items,
      },
    );
  }

  public async disregardValue(
    companyGroupId: number,
    grouperType: CashFlowTablesEnum,
    items: IDisreguardTotalsByGroupRequestParams[],
  ): Promise<void> {
    await this.datasource.patch(
      `company-groups/${companyGroupId}/cash-flow/predicted/actions/disregard`,
      {
        grouper_table: grouperType,
        items,
      },
    );
  }
}
